/** Static labels and hover descriptions for the Treatment Rate widget. */

export const TREATMENT_RATE_LABELS = {
  treatmentRate: "Treatment Rate",
  percentagePending: "Potential Treatment Rate",
  timeToTherapy: "Time to Therapy",
};

export const TREATMENT_RATE_LABEL_DESCRIPTIONS = {
  treatmentRate:
    "Percentage of referrals converted to starts for the prescribed therapy and referral month",
  percentagePending:
    "Projected treatment rate if all pending referrals convert to starts for the prescribed therapy and referral month",
  timeToTherapy:
    "Median number of calendar days from referral date to therapy start (where start = first shipment date)",
};

export const TREATMENT_RATE_WIDGET_TEXT = {
  title: "Treatment Rate and Median Calendar Days to Therapy",
  switchTitle: "Treatment Rate & Days to Therapy",
  subtitle: "TYVASO · Referral Month",
  subtitleSuffix: "Referral Month",
  emptyMessage: "No data found",
  errorMessage: "Unable to load treatment rate data",
  referralMonthAxis: "Referral Month",
  leftAxis: "TYVASO / Trt Rate/Potential",
  rightAxis: "Time to Therapy",
};
